import React from "react";
import { View, Dimensions } from "react-native";
import LottieView from "lottie-react-native";
// // import { ENV_TYPE } from "@env";

const { width, height } = Dimensions.get("window");

const CIRCLE_WIDTH = 0.2 * width;
const CONTAINER_WIDTH = 0.15 * width;
const CONTAINER_HEIGHT = 0.15 * width;

export default class EndSessionLottie extends React.Component {
  componentDidMount() {
    // if (ENV_TYPE !== "testing") {
    // this.animation.play(0, 32);
    this?.animation?.play();
    // }
    // Or set a specific startFrame and endFrame with:
  }

  render() {
    return (
      // <View style={styles.mainView}>
      <LottieView
        ref={animation => {
          this.animation = animation;
        }}
        loop={true}
        style={styles.animationStyle}
        source={require("../../../assets/lottie/trophy-bubble.json")}
        // source={require("../../../assets/lottie/trophy.json")}
      />
      // </View>
    );
  }
}

const styles = {
  animationStyle: {
    height: width * 0.6,
    width: width * 0.6,
  },
};
